import { useTranslation } from "react-i18next";
import { SETTINGS_WIZARD_OUTER_MAX_WIDTH_PX } from "./settingsWizardConstants";

/**
 * Footer fixé en bas du viewport — parcours de création Paramètres.
 * Ordre : Retour (si étape > 0) | séparateur | Quitter | action primaire.
 */
const SettingsWizardFooter = ({
  stepIndex = 0,
  saving = false,
  onBack,
  onQuit,
  quitLabel,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  innerMaxWidth = SETTINGS_WIZARD_OUTER_MAX_WIDTH_PX,
  innerClassName = "",
}) => {
  const { t } = useTranslation();
  const showBack = stepIndex > 0;

  return (
    <div className="settings-wizard-footer">
      <div
        className={`settings-wizard-footer__inner ${innerClassName}`.trim()}
        style={{ maxWidth: innerMaxWidth }}
      >
        {showBack && onBack && (
          <>
            <button
              type="button"
              className="modal-button modal-button-cancel"
              disabled={saving}
              onClick={onBack}
            >
              {t("Back")}
            </button>
            <span className="h-8 w-px bg-[#d3d3d3] mx-1" aria-hidden />
          </>
        )}
        <button
          type="button"
          className="modal-button modal-button-cancel"
          disabled={saving}
          onClick={onQuit}
        >
          {quitLabel}
        </button>
        <button
          type="button"
          className={`modal-button modal-button-save ${saving ? "disabled" : ""}`}
          disabled={primaryDisabled ?? saving}
          onClick={onPrimary}
        >
          {primaryLabel}
        </button>
      </div>
    </div>
  );
};

export default SettingsWizardFooter;
